import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es un pago único o una suscripción mensual?',
    a: 'Pago único de $6.36 USD. Sin suscripciones, sin cargos recurrentes, sin sorpresas en tu tarjeta. Pagas una vez y el sistema es tuyo para siempre.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu pago recibirás un email con los enlaces de descarga directa de los 6 PDFs. Puedes leerlos en tu celular, tablet o computadora, o imprimirlos si prefieres.'
  }, {
    q: '¿Funciona si ya estoy en la menopausia?',
    a: 'Especialmente si estás en la menopausia. El protocolo ataca directamente los desequilibrios hormonales que se intensifican durante y después de la menopausia.'
  }, {
    q: '¿Tengo que comprar suplementos caros?',
    a: 'No. El protocolo está basado 100% en comida real que encuentras en cualquier mercado o supermercado.'
  }, {
    q: '¿Sirve si vivo en México? ¿Y si vivo en Estados Unidos?',
    a: 'Sirve para ambos. La lista de compras incluye opciones específicas para Walmart, Costco, Soriana y Chedraui.'
  }, {
    q: '¿Tengo que dejar de comer con mi familia?',
    a: 'Absolutamente no. Las recetas funcionan para toda la familia. Solo tú sabrás que estás siguiendo un protocolo metabólico.'
  }, {
    q: '¿En cuánto tiempo veré resultados?',
    a: 'Energía y antojos: días 5-7. Inflamación y sueño: días 10-14. Cambios en medidas: días 21-30.'
  }];
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <section className="w-full bg-lightGray py-16 px-4" data-id="element-40">
      <div className="max-w-[760px] mx-auto" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-42">
          <h2 className="text-[32px] font-bold text-dark inline-block relative" data-id="element-43">
            Preguntas Frecuentes
            <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-16 h-1 bg-teal rounded-full" data-id="element-44"></div>
          </h2>
        </motion.div>

        <div className="flex flex-col gap-2" data-id="element-45">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="bg-white rounded-xl overflow-hidden shadow-sm hover:bg-teal-light/30 transition-colors" data-id="element-46">
                <button onClick={() => setOpenIndex(isOpen ? -1 : index)} className="w-full flex items-center gap-4 p-5 text-left focus:outline-none" data-id="element-47">
                  <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-teal text-white' : 'bg-teal/10 text-teal'}`} data-id="element-48">
                    {isOpen ? <Minus size={14} data-id="element-49" /> : <Plus size={14} data-id="element-50" />}
                  </div>
                  <span className="font-bold text-[16px] text-dark flex-grow" data-id="element-51">
                    {faq.q}
                  </span>
                </button>

                <AnimatePresence data-id="element-52">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-53">
                      <div className="px-5 pb-5 pt-2 ml-10 border-t border-gray-50" data-id="element-54">
                        <p className="text-[15px] text-[#555] leading-[1.8]" data-id="element-55">
                          {faq.a}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}